import { render, staticRenderFns } from "./UpdateHistories.vue?vue&type=template&id=5adae7c6&scoped=true"
import script from "./UpdateHistories.vue?vue&type=script&lang=js"
export * from "./UpdateHistories.vue?vue&type=script&lang=js"
import style0 from "./UpdateHistories.vue?vue&type=style&index=0&id=5adae7c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5adae7c6",
  null
  
)

export default component.exports